import countrySlice from "./country/slice/countrySlice";
import magentoSlice from "./magento/slice/magentoSlice";
import deviceSlice from "./devices/slice/deviceSlice";
import organisationSlice from "./organisations/slice/organisationSlice";
import eventEditionSlice from "./eventEdition/slice/eventEditionSlice";
import metadataSlice from "./metadata/slice/metadataSlice";

const rootReducer = {
  eventEdition: eventEditionSlice,
  magento: magentoSlice,
  metadata: metadataSlice,
  country: countrySlice,
  devices: deviceSlice,
  organisations: organisationSlice,
};

export default rootReducer;
